/**
 * @desc 根据批次或者箱号获取po信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.BoxRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/fulfilment/getPoInfoByBatchNoOrBoxNo`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
